import { render, staticRenderFns } from "./CnTable.vue?vue&type=template&id=71dc3a92&"
import script from "./CnTable.vue?vue&type=script&lang=js&"
export * from "./CnTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports